import InputEntity from '@/lib/formFactory/inputEntity';

export default class EntityModel {
    model: any;

    constructor() {
        const title = new InputEntity('title');
        title.setTitle('Название');
        title.setRequired(true);

        const sort = new InputEntity('sort');
        sort.setTitle('Сортировка');
        sort.setRequired(true);

        this.model = {
            title: title.entity[title.entityName],
            sort: sort.entity,
        };
    }
}
